import ButtonComponent from 'components/button';
import type * as PI from 'interfaces/project';
import { PHOTO_DETECTED_FOR_LIMITED_COLOR_LOGO_ERROR_CODE } from 'interfaces/project';
import { UIModule } from 'store';
import { componentSlot } from 'store/ui';

interface LimitedColorLogoPhotoErrorDialogOptions {
	onClose?: () => void;
}

let activeClose: (() => void) | undefined;
let activeCloseDialog: (() => void) | undefined;
let activeCloseCallbacks: Array<() => void> = [];

export function isLimitedColorLogoPhotoError(photoModel: PI.PhotoModel): boolean {
	return photoModel._error?.code === PHOTO_DETECTED_FOR_LIMITED_COLOR_LOGO_ERROR_CODE;
}

export function openLimitedColorLogoPhotoErrorDialog(options?: LimitedColorLogoPhotoErrorDialogOptions): () => void {
	if (options?.onClose) {
		activeCloseCallbacks.push(options.onClose);
	}

	if (activeClose) {
		return activeClose;
	}

	let closed = false;
	const close = (): void => {
		if (closed) {
			return;
		}

		closed = true;
		const closeDialog = activeCloseDialog;
		const closeCallbacks = activeCloseCallbacks.slice(0);
		activeClose = undefined;
		activeCloseDialog = undefined;
		activeCloseCallbacks = [];
		closeDialog?.();
		closeCallbacks.forEach((callback) => callback());
	};

	activeClose = close;
	activeCloseDialog = UIModule.openDialog({
		header: componentSlot({
			slot: window.App.router.$t('dialogs.photoNotSupportedLimitedColors.title'),
		}),
		body: componentSlot({
			slot: window.App.router.$t('dialogs.photoNotSupportedLimitedColors.message'),
		}),
		footer: componentSlot({
			tag: ButtonComponent,
			props: {
				class: 'grow',
				onClick: close,
			},
			slot: window.App.router.$t('dialogs.photoNotSupportedLimitedColors.buttons.accept'),
		}),
		props: {
			onClose: close,
			'onClick:outside': close,
		},
	});

	return close;
}
